module.exports = "mutation ($id: ID!, $data: TaskUpdate!) {\n  TaskUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"